import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import VendorStoreMenu from '../components/VendorStoreMenu';
import VendorStoreAutoOrder from '../components/VendorStoreAutoOrder';
import VendorStoreCalc from '../components/VendorStoreCalc';
import VendorStoreMachine from '../components/VendorStoreMachine';
import VendorStoreCctv from '../components/VendorStoreCctv';

const VendorStoreDetail = () => {
    const { storeNo } = useParams();
    const [category, setCategory] = useState('autoOrder');
    const onSelect = useCallback(category => setCategory(category), []);

    let renderedComponent;
    switch (category) {
        case 'autoOrder':
            renderedComponent = <VendorStoreAutoOrder storeId={storeNo} />;
            break;
        case 'calc':
            renderedComponent = <VendorStoreCalc storeId={storeNo} />;
            break;
        case 'machine':
            renderedComponent = <VendorStoreMachine storeId={storeNo} />;
            break;
        case 'cctv':
            renderedComponent = <VendorStoreCctv storeId={storeNo} />;
            break;
        default:
            renderedComponent = null;
            break;
    }

    return (
        <div style={{ padding: '1.5rem' }}>
            {/* <div>VendorStoreDetail storeId : {storeInfo.storeId}</div> */}
            {/* 자동 발주 내역 */}
            {/* 정산 내역 - 해당 상점의 매출, 본사 기준에서 정산해야 할 돈, 본사의 순 이익 */}
            {/* 자판기 상태 관리(키오스크, 머신) */}
            {/* 매장 제어(CCTV) */}
            <VendorStoreMenu category={category} onSelect={onSelect} />
            <div style={{ padding: '1.5rem 0 0' }}>{renderedComponent}</div>
        </div>
    );
};

export default VendorStoreDetail;
